import React, { useState } from "react";
import { Badge, Button, Modal, Nav, Tab } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate, faClockRotateLeft, faStore } from "@fortawesome/free-solid-svg-icons";
import { useWooJobs } from "../../../contexts/WooJobsContext";
import WooSyncOrders from "./WooSyncOrders";
import WooJobsHistory from "./WooJobsHistory";

/**
 * Launcher button + Modal that hosts the WooCommerce sync form and the
 * background jobs history. Saves vertical space on the Orders page since
 * the sync flow is occasional. The launcher shows a live badge with the
 * count of active (queued / running) jobs so the user can spot in-flight
 * work without opening the modal.
 */
const WooSyncModal = ({ defaultTab = "sync" }) => {
  const [show, setShow] = useState(false);
  const [tab, setTab] = useState(defaultTab);
  const { activeJobs } = useWooJobs();

  const activeCount = activeJobs?.length || 0;
  const hasRunning = activeJobs?.some((j) => j.status === "running");

  return (
    <>
      <Button
        variant={activeCount > 0 ? "primary" : "outline-primary"}
        size="sm"
        onClick={() => setShow(true)}
        className="d-inline-flex align-items-center gap-2"
        title="Đồng bộ đơn WooCommerce"
      >
        <FontAwesomeIcon icon={faRotate} spin={hasRunning} />
        <span>Sync WooCommerce</span>
        {activeCount > 0 && (
          <Badge bg="light" text="primary" pill>{activeCount}</Badge>
        )}
      </Button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        size="xl"
        scrollable
        backdrop="static"
        aria-labelledby="woo-sync-modal-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="woo-sync-modal-title" className="d-flex align-items-center gap-2">
            <FontAwesomeIcon icon={faStore} className="text-primary" />
            Đồng bộ đơn hàng WooCommerce
            {activeCount > 0 && (
              <Badge bg="primary" pill className="ms-2">{activeCount} đang chạy</Badge>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-light">
          <Tab.Container activeKey={tab} onSelect={(k) => k && setTab(k)}>
            <Nav variant="tabs" className="mb-3">
              <Nav.Item>
                <Nav.Link eventKey="sync" className="d-inline-flex align-items-center gap-2">
                  <FontAwesomeIcon icon={faRotate} />Đồng bộ
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="history" className="d-inline-flex align-items-center gap-2">
                  <FontAwesomeIcon icon={faClockRotateLeft} />Lịch sử Jobs
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Tab.Content>
              <Tab.Pane eventKey="sync" mountOnEnter unmountOnExit={false}>
                <WooSyncOrders />
              </Tab.Pane>
              <Tab.Pane eventKey="history" mountOnEnter unmountOnExit={false}>
                <WooJobsHistory />
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>Đóng</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default WooSyncModal;
